import React from 'react';
import { useTranslations } from 'next-intl';
import { Card, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';

interface AuthSuccessProps {
  title?: string;
  description?: string;
}

/**
 * AuthSuccess - Reusable success message card for post-authentication actions
 * Displays a success state with consistent styling and optional custom messaging
 */
export function AuthSuccess({
  title,
  description,
}: AuthSuccessProps) {
  const t = useTranslations('auth.authSuccess');

  return (
    <Card>
      <CardHeader className="space-y-s1">
        <CardTitle className="text-lg text-center text-success">
          {title ?? t('defaultTitle')}
        </CardTitle>
        <CardDescription className="text-center">
          {description ?? t('defaultDescription')}
        </CardDescription>
      </CardHeader>
    </Card>
  );
}
